import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    this.videos = [...this.el.querySelectorAll('.wp-block-video video')]
    this.videos.forEach((video) => this.classify(video))
  }

  classify(video) {
    const apply = () => {
      const block = video.closest('.wp-block-video')
      if (!block || !video.videoWidth || !video.videoHeight) return

      const isLandscape = video.videoWidth >= video.videoHeight
      block.classList.toggle('is-landscape', isLandscape)
      block.classList.toggle('is-portrait', !isLandscape)
    }

    if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
      apply()
    } else {
      video.addEventListener('loadedmetadata', apply, { once: true })
    }
  }
}
